import React from "react";
import { money2 } from "../payrollHelpers";

export default function AdjustmentsTab({ adjustments, onApprove, isLocked }) {
  const list = adjustments || [];
  if (list.length === 0) {
    return <div className="text-center text-slate-400 italic py-8" data-testid="payroll-adjustments-tab">No adjustments recorded for this employee.</div>;
  }
  return (
    <table className="w-full text-[12.5px]" data-testid="payroll-adjustments-tab">
      <thead className="border-b border-slate-200">
        <tr className="text-[10.5px] uppercase tracking-wider font-semibold text-slate-500">
          <th className="text-left py-1.5">Date</th>
          <th className="text-left py-1.5">Category</th>
          <th className="text-right py-1.5">Original</th>
          <th className="text-right py-1.5">Adjustment</th>
          <th className="text-right py-1.5">Final</th>
          <th className="text-left py-1.5">Reason</th>
          <th className="text-left py-1.5">Created By</th>
          <th className="text-left py-1.5">Status</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-slate-100">
        {list.map((a) => (
          <tr key={a.id} data-testid={`adjustment-row-${a.id}`}>
            <td className="py-2">{new Date(a.createdAt).toLocaleDateString()}</td>
            <td className="py-2">{a.category}</td>
            <td className="py-2 text-right">{money2(a.originalAmount)}</td>
            <td className={`py-2 text-right ${a.adjustmentAmount >= 0 ? "text-emerald-600" : "text-rose-600"}`}>{a.adjustmentAmount >= 0 ? "+" : ""}{a.category === "TIME" ? a.adjustmentAmount.toFixed(2) : money2(a.adjustmentAmount)}</td>
            <td className="py-2 text-right font-semibold">{a.category === "TIME" ? a.finalAmount.toFixed(2) : money2(a.finalAmount)}</td>
            <td className="py-2 text-slate-600">{a.reason}</td>
            <td className="py-2 text-slate-500">{a.createdBy}</td>
            <td className="py-2">
              {onApprove ? (
                <button
                  type="button"
                  disabled={isLocked}
                  onClick={() => onApprove(a.id, !a.approvedBy)}
                  data-testid={`adjustment-approve-toggle-${a.id}`}
                  className={`text-[10.5px] font-bold px-1.5 py-0.5 rounded disabled:cursor-not-allowed disabled:opacity-60 ${a.approvedBy ? "bg-emerald-50 text-emerald-700 hover:bg-emerald-100" : "bg-amber-50 text-amber-700 hover:bg-amber-100"}`}
                >
                  {a.approvedBy ? "Approved ✓" : "Pending — Approve"}
                </button>
              ) : (
                <span className={`text-[10.5px] font-bold px-1.5 py-0.5 rounded ${a.approvedBy ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>
                  {a.approvedBy ? "Approved" : "Pending"}
                </span>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
